
import { Injectable } from '@angular/core';
import { ClientBase, Member } from '../shared/core/ovs.core';
import { CookieService } from '@ngx-toolkit/cookie';



@Injectable()
export class MemberClient extends ClientBase {

	constructor(private cookieService: CookieService) {
		super();
	}

	public GetMemberInfo(success?: (value: Member) => void, error?: (error: any) => void): void {
		this.baseGet<Member>("api/MemberInfo", Member, null, success, error);
	}


}







// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/member-info.client.ts